<template>
  <nav class="navbar is-spaced" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <router-link class="navbar-item" :to="{ name: 'manager' }">
          <img src="https://app.wavve.co/img/logo-light-text.fb54e365.png" alt="Wavve Logo" />
        </router-link>
        <a id="navbarMenuBurger" role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
          data-target="navbarMenu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" id="navbarMenu">
        <div class="navbar-start">
          <router-link :to="{ name: 'manager' }">Manage Users</router-link>
          <router-link :to="{ name: 'reports' }">View Jobs</router-link>
          <!-- <router-link :to="{ name: 'metrics' }">Metrics</router-link> -->
          <!-- <router-link :to="{ name: 'conference' }">Sharing</router-link> -->
          <a @click="logout" class="navbar-item">Logout</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "TheNavbar",
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    const $navbarBurgers = Array.prototype.slice.call(
      document.querySelectorAll(".navbar-burger"),
      0
    );
    if ($navbarBurgers.length > 0) {
      $navbarBurgers.forEach(el => {
        el.addEventListener("click", () => {
          const { target } = el.dataset;
          const $target = document.getElementById(target);
          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle("is-active");
          $target.classList.toggle("is-active");
        });
      });
    }
  },
  methods: {
    async logout() {
      localStorage.removeItem('token');
      await this.$store.dispatch(LOGOUT);
    },
  },
  watch: {
    // eslint-disable-next-line
    $route() {
      const elements = [
        document.getElementById("navbarMenu"),
        document.getElementById("navbarMenuBurger")
      ];
      elements.forEach(el => {
        if (el) {
          el.classList.remove("is-active");
        }
      });
    }
  }
};
</script>
